<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="TIPO_COBRANCA"
          label="Tipo de cobrança"
          required
          class="required rounded-tag-small"
          v-model="formData.tipoCobranca"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
